const CTA_STORAGE_KEY = "prusa_cta_clicks";

export interface CTAClick {
  label: string;
  page: string;
  timestamp: string;
}

export function trackCTA(label: string): void {
  try {
    const stored = sessionStorage.getItem(CTA_STORAGE_KEY);
    const clicks: CTAClick[] = stored ? JSON.parse(stored) : [];
    clicks.push({
      label,
      page: window.location.pathname,
      timestamp: new Date().toISOString(),
    });
    // Keep last 10 clicks
    sessionStorage.setItem(CTA_STORAGE_KEY, JSON.stringify(clicks.slice(-10)));
  } catch {
    // silent fail
  }
}

export function getCTAClicks(): CTAClick[] {
  try {
    const stored = sessionStorage.getItem(CTA_STORAGE_KEY);
    return stored ? JSON.parse(stored) : [];
  } catch {
    return [];
  }
}

export function getCTATags(): string[] {
  const clicks = getCTAClicks();
  const labels = new Set(clicks.map((c) => `cta-${c.label.toLowerCase().replace(/\s+/g, "-").slice(0, 30)}`));
  return Array.from(labels);
}
